import React from 'react'
import AdminBranchDataContent from '../../Component/AdminBranchDataContent/AdminBranchDataContent'

function AdminBranchData() {
  return  <AdminBranchDataContent />
   
}

export default AdminBranchData
